"use client";

import { useTheme } from "next-themes";
import { useState, useEffect } from "react";
import { RefreshCw } from "lucide-react";

const CAPTCHA_KEY = "captcha_solution";

export default function AntiSpamCaptcha({ onVerify }: { onVerify: (isValid: boolean) => void }) {
    const [captcha, setCaptcha] = useState("");
    const [userInput, setUserInput] = useState("");
    const { resolvedTheme } = useTheme();
    const [mounted, setMounted] = useState(false);

    const generateCaptcha = () => {
        const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
        let result = "";
        for (let i = 0; i < 5; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        setCaptcha(result);
        onVerify(false);
        setUserInput("");
    };

    useEffect(() => {
        setMounted(true);
        generateCaptcha();
    }, []);

    useEffect(() => {
        if (userInput.toUpperCase() === captcha) {
            onVerify(true);
        } else {
            onVerify(false);
        }
    }, [userInput, captcha, onVerify]);

    if (!mounted) return null;

    return (
        <div style={{
            padding: "1.25rem",
            background: resolvedTheme === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)",
            borderRadius: "1rem",
            border: "1px solid var(--border)",
            display: "flex",
            flexDirection: "column",
            gap: "1rem"
        }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span style={{ fontSize: "0.75rem", fontWeight: 800, textTransform: "uppercase", color: "var(--muted-foreground)" }}>Vérification de sécurité</span>
                <button type="button" onClick={generateCaptcha} style={{ background: "none", border: "none", color: "var(--primary)", display: "flex", alignItems: "center", gap: "0.25rem", fontSize: "0.75rem", fontWeight: 700 }}>
                    <RefreshCw size={14} /> Actualiser
                </button>
            </div>

            <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
                <div style={{
                    padding: "0.75rem 1.5rem",
                    background: "var(--primary)",
                    color: "white",
                    borderRadius: "0.5rem",
                    fontSize: "1.25rem",
                    fontWeight: 900,
                    letterSpacing: "0.2em",
                    fontFamily: "monospace",
                    userSelect: "none",
                    boxShadow: "inset 0 0 10px rgba(0,0,0,0.2)"
                }}>
                    {captcha}
                </div>

                <input
                    type="text"
                    placeholder="Recopiez le code"
                    value={userInput}
                    onChange={(e) => setUserInput(e.target.value)}
                    className="form-input"
                    style={{ flex: 1, textTransform: "uppercase" }}
                />
            </div>
            {userInput && userInput.toUpperCase() === captcha && (
                <p style={{ fontSize: "0.75rem", color: "#16a34a", fontWeight: 700 }}>✓ Code vérifié</p>
            )}
        </div>
    );
}
